var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7024 12.7034C23.0929 12.3129 23.0929 11.6787 22.7024 11.2881L19.7033 8.28898C19.3127 7.89846 18.6785 7.89846 18.288 8.28898C17.8975 8.6795 17.8975 9.31369 18.288 9.70421L19.5814 10.9976H9.99972C9.44675 10.9976 9 11.4444 9 11.9973C9 12.5503 9.44675 12.997 9.99972 12.997H19.5814L18.288 14.2904C17.8975 14.6809 17.8975 15.3151 18.288 15.7057C18.6785 16.0962 19.3127 16.0962 19.7033 15.7057L22.7024 12.7065V12.7034ZM12.2897 23.7003C12.6802 24.0908 13.3144 24.0908 13.7049 23.7003C14.0955 23.3098 14.0955 22.6756 13.7049 22.2851L12.4147 20.9948H21.9964C22.5493 20.9948 22.9961 20.5481 22.9961 19.9951C22.9961 19.4421 22.5493 18.9954 21.9964 18.9954H12.4147L13.7081 17.702C14.0986 17.3115 14.0986 16.6773 13.7081 16.2867C13.3175 15.8962 12.6833 15.8962 12.2928 16.2867L9.29367 19.2859C8.90315 19.6764 8.90315 20.3106 9.29367 20.7011L12.2928 23.7003H12.2897Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConvert);
export default __webpack_public_path__ + "static/media/icon-convert.4fb0543bd0cd694329607047003aefff.svg";
export { ForwardRef as ReactComponent };